import * as actionTypes from '../actions/types';
import { updateObject } from '../../constants/utility';

/**
 * `offerId` records which offer the tracked request belongs to. Several offer
 * cards can be on screen at once, so consumers must compare it against their own
 * offer before reacting to `isLoading` / `isComplete` / `error`.
 */
const initialState = {
    isLoading: false,
    isComplete: null,
    error: null,
    data: null,
    offerId: null,
};

const workingCapitalAcceptanceStart = (state, action) =>
    updateObject(state, {
        isLoading: true,
        isComplete: false,
        error: null,
        data: null,
        offerId: action.offerId ?? null,
    });

const workingCapitalAcceptanceSuccess = (state, action) =>
    updateObject(state, {
        isLoading: false,
        isComplete: true,
        error: null,
        data: action.data,
        offerId: action.offerId ?? null,
    });

const workingCapitalAcceptanceFail = (state, action) =>
    updateObject(state, {
        isLoading: false,
        isComplete: null,
        error: action.error,
        data: null,
        offerId: action.offerId ?? null,
    });

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.WORKING_CAPITAL_ACCEPTANCE_START:
            return workingCapitalAcceptanceStart(state, action);
        case actionTypes.WORKING_CAPITAL_ACCEPTANCE_SUCCESS:
            return workingCapitalAcceptanceSuccess(state, action);
        case actionTypes.WORKING_CAPITAL_ACCEPTANCE_FAIL:
            return workingCapitalAcceptanceFail(state, action);
        case actionTypes.WORKING_CAPITAL_ACCEPTANCE_RESET:
            return initialState;
        default:
            return state;
    }
};

export default reducer;
